<template>
  <v-row>
    <!-- <v-flex sm12>
      <span class="grey--text">{{$t('companies.required_fields')}} ({{$t('companies.name')}}, {{$t('companies.ico')}})</span>
    </v-flex> -->
    <v-col sm="6">
      <v-text-field
        :label="$t('companies.name') + ' *'"
        v-model="company.name"
        :rules="[v => !!v || $t('general.required_field')]"
      ></v-text-field>
    </v-col>
    <v-col sm="6">
      <v-text-field
        :label="$t('companies.ico') + ' *'"
        v-model="company.regNo"
        :rules="[v => !!v || $t('general.required_field')]"
        :disabled="isUpdate"
      ></v-text-field>
    </v-col>
    <v-col sm="6">
      <v-text-field
        :label="$t('companies.ref')"
        v-model="company.ref"
        :disabled="isUpdate"
      ></v-text-field>
    </v-col>
    <v-col sm="6">
      <v-text-field
        :label="$t('companies.dic')"
        v-model="company.vatNo"
        :disabled="isUpdate"
      ></v-text-field>
    </v-col>
    <v-col sm="6">
      <v-text-field
        :label="$t('companies.web')"
        v-model="company.web"
        :disabled="isUpdate"
      ></v-text-field>
    </v-col>
    <v-col sm="6">
      <v-text-field :label="$t('companies.avatar')" @click='pickFile' v-model='company.avatar' :disabled="isUpdate"></v-text-field>
      <input
        type="file"
        style="display: none"
        ref="image"
        accept="image/*"
        @change="onFilePicked"
        :disabled="isUpdate"
      >
    </v-col>
    <v-col sm="12">
      <v-combobox
        v-if="isUpdate && company.id !== signedInCompany.id"
        v-model="company.groups"
        :items="groups"
        :search-input.sync="search"
        :label="$t('companies.groups')"
        multiple
        small-chips
        hide-selected
        deletable-chips
      >
        <template v-slot:no-data>
          <div class="px-3">
            <p v-html="$t('general.combobox_no_results', {'search': search})"></p>
          </div>
        </template>
      </v-combobox>
    </v-col>
    <v-col sm="12">
      <v-textarea
        outlined
        :label="$t('companies.description')"
        v-model="company.description"
      ></v-textarea>
    </v-col>
  </v-row>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'CompanyFormOverview',
  props: {
    value: Object,
    isUpdate: Boolean
  },
  data () {
    return {
      company: JSON.parse(JSON.stringify(this.value)),
      imageUrl: '',
      imageFile: '',
      labels: ['Industry A', 'Industry B', 'Industry C'],
      groups: ['Group A', 'Group B', 'Group C'],
      search: null
    }
  },
  computed: {
    ...mapState(['signedInCompany'])
  },
  watch: {
    company: {
      deep: true,
      handler (value) {
        this.$emit('input', value)
      }
    }
  },
  methods: {
    pickFile () {
      this.$refs.image.click()
    },

    onFilePicked (e) {
      const files = e.target.files
      if (files[0] !== undefined) {
        this.$set(this.company, 'avatar', files[0].name)
        if (this.company.avatar.lastIndexOf('.') <= 0) {
          return
        }
        const fr = new FileReader()
        fr.readAsDataURL(files[0])
        fr.addEventListener('load', () => {
          this.imageUrl = fr.result
          this.imageFile = files[0] // this is an image file that can be sent to server...
        })
      } else {
        this.company.avatar = ''
        this.imageFile = ''
        this.imageUrl = ''
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  ::v-deep .v-textarea .v-input__slot {
        border: 1px solid rgba(0,0,0,.54) !important;
  }
</style>
